/** Penggabung className sederhana — tanpa dependensi. */
export function cn(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
